<template>
    <TableLayout :permissions="['business:membercard:query']">
        <!-- 搜索表单 -->
        <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="100px" inline>
            <el-form-item label="卡号" prop="code">
                <el-input v-model="searchForm.code" placeholder="请输入卡号" @keypress.enter.native="search"></el-input>
            </el-form-item>
            <el-form-item label="姓名/手机号" prop="keyword">
                <el-input v-model="searchForm.keyword" placeholder="请输入员工姓名/手机号" @keypress.enter.native="search"></el-input>
            </el-form-item>
            <el-form-item label="用户类型" prop="memberType">
                <el-select v-model="searchForm.memberType" placeholder="请选择">
                    <el-option label="劳务人员" :value="0"></el-option>
                    <el-option label="内部员工" :value="2"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="状态" prop="status">
                <el-select v-model="searchForm.status" placeholder="请选择">
                    <el-option label="禁用" :value="0"></el-option>
                    <el-option label="启用" :value="1"></el-option>
                    <el-option label="退卡" :value="2"></el-option>
                    <el-option label="挂失" :value="3"></el-option>
                </el-select>
            </el-form-item>
            <section>
                <el-button type="primary" @click="search">搜索</el-button>
                <el-button @click="reset">重置</el-button>
            </section>
        </el-form>
        <!-- 表格和分页 -->
        <template v-slot:table-wrap>
            <ul class="toolbar" v-permissions="['business:membercard:create']">
                <li><el-button type="primary" @click="$refs.operaMemberCardWindow.open('新建用户卡片绑定信息表')" icon="el-icon-plus" v-permissions="['business:membercard:create']">新建</el-button></li>
                <li><el-button type="primary" @click="batchLossReporting">挂失</el-button></li>
                <li><el-button type="primary" @click="batchDecoupling">解挂</el-button></li>
            </ul>
            <el-table
                v-loading="isWorking.search"
                :data="tableData.list"
                stripe
                @selection-change="handleSelectionChange"
            >
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column prop="code" label="卡号" min-width="100px"></el-table-column>
                <el-table-column prop="cardTypeName" label="卡类型" min-width="100px"></el-table-column>
                <el-table-column label="状态" min-width="100px">
                    <template slot-scope="{row}">
                        <span v-if="row.status === 0">禁用</span>
                        <span v-if="row.status === 1">启用</span>
                        <span v-if="row.status === 2">退卡</span>
                        <span v-if="row.status === 3">挂失</span>
                    </template>
                </el-table-column>
                <el-table-column label="用户类型" min-width="100px">
                    <template slot-scope="{row}">
                        <span v-if="row.memberType === 0">劳务访客</span>
                        <span v-if="row.memberType === 2">内部人员</span>
                    </template>
                </el-table-column>
                <el-table-column prop="memberName" label="员工姓名" min-width="100px"></el-table-column>
                <el-table-column prop="memberPhone" label="手机号" min-width="100px"></el-table-column>
                <el-table-column prop="companyName" label="公司/部门" min-width="100px"></el-table-column>
                <el-table-column prop="createDate" label="开卡时间" min-width="100px"></el-table-column>
                <el-table-column prop="editDate" label="更新时间" min-width="100px"></el-table-column>
                <el-table-column
                    label="操作"
                    min-width="120"
                    fixed="right"
                >
                    <template slot-scope="{row}">
                        <el-button type="text" v-if="row.status === 3" @click="jiegua(row.id)">解挂</el-button>
                        <el-button type="text" v-if="row.status !== 3 && row.status !== 2" @click="tui(row.id)">退卡</el-button>
                        <el-button type="text" v-if="row.status !== 3 && row.status !== 2" @click="guashi(row.id)">挂失</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <pagination
                @size-change="handleSizeChange"
                @current-change="handlePageChange"
                :pagination="tableData.pagination"
            >
            </pagination>
        </template>
        <!-- 新建/修改 -->
        <OperaMemberCardWindow ref="operaMemberCardWindow" @success="handlePageChange"/>
    </TableLayout>
</template>

<script>
  import BaseTable from '@/components/base/BaseTable'
  import TableLayout from '@/layouts/TableLayout'
  import Pagination from '@/components/common/Pagination'
  import OperaMemberCardWindow from '@/components/business/OperaMemberCardWindow'
  import { refundCard, batchLoss, batchUnLoss } from '@/api/business/memberCard'
  export default {
    name: 'MemberCard',
    extends: BaseTable,
    components: { TableLayout, Pagination, OperaMemberCardWindow },
    data () {
      return {
        // 搜索
        searchForm: {
          code: '',
          keyword: '',
          status: '',
          memberType: ''
        }
      }
    },
    created () {
      this.config({
        module: '用户卡片绑定信息表',
        api: '/business/memberCard',
        'field.id': 'id',
        'field.main': 'id'
      })
      this.search()
    },
    methods: {
      // 批量解挂
      batchDecoupling () {
        let arr = []
        this.tableData.selectedRows.forEach(item => {
          arr.push({ id: item.id, status: 1 })
        })
        batchUnLoss(arr)
          .then(res => {
            this.$message.success('操作成功')
            this.search()
          })
      },
      // 批量挂失
      batchLossReporting() {
        let arr = []
        this.tableData.selectedRows.forEach(item => {
          arr.push({ id: item.id, status: 3 })
        })
        batchLoss(arr)
          .then(res => {
            this.$message.success('操作成功')
            this.search()
          })
      },
      // 退卡
      tui(id) {
        refundCard({ id, status: 2 })
          .then(res => {
            this.$message.success('操作成功')
            this.search()
          })
      },
      // 挂失
      guashi(id) {
        batchLoss([{ id, status: 3 }])
          .then(res => {
            this.$message.success('操作成功')
            this.search()
          })
      },
      // 解挂
      jiegua(id) {
        batchUnLoss([{ id, status: 1 }])
          .then(res => {
            this.$message.success('操作成功')
            this.search()
          })
      }
    }
  }
</script>
